import React, {useState, useEffect} from 'react';
import RedeemCard from './RedeemCard';
import './styles.css';
import NavBar from './Navbar';
import axios from 'axios';

// import NavBar from './Navbar';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Redeem Page.
  */
function Redeem() {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios.get(`https://blooming-springs-86289.herokuapp.com/api/redeem/values`)
        .then((response) => {
          return (
            setData(response.data)
          );
        });
  }, []);

  return (
    <>
      <NavBar />
      <div className='redeem'>Redeem Vouchers</div>
      {data.map((item, index) => {
        return (
          <RedeemCard
            promoId={item.promo_id}
            amount={item.amount}
            required_points={item.required_points}
            key={index}
          />
        );
      })}
    </>
  );
};

export default Redeem;

